<template>
  <div class="container login-page">
    <Menu>
      <template #heading>
        <h1>Reset Password</h1>
      </template>
      <template #content>
        <div class="container">
          <div v-if="hasErrors" class="error-messages">
            <ul>
              <li v-for="error in errors" :key="error.code">
                {{ error.message }}
              </li>
            </ul>
          </div>
          <form class="form" @submit.prevent="handleResetSubmit">
            <label class="field">
              <div class="input">
                <input
                  v-model.trim="password"
                  type="password"
                  autocomplete="new-password"
                  class="input__element"
                  placeholder="New password"
                />
                <div v-if="v$.password.$dirty" class="input__response">
                  <ul>
                    <li v-for="error of v$.password.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </li>
                  </ul>
                </div>
              </div>
            </label>
            <label class="field">
              <div class="input">
                <input
                  v-model.trim="confirm"
                  type="password"
                  autocomplete="new-password"
                  class="input__element"
                  placeholder="Confirm new password"
                />
                <div v-if="v$.confirm.$dirty" class="input__response">
                  <ul>
                    <li v-for="error of v$.confirm.$errors" :key="error.$uid">
                      {{ error.$message }}
                    </li>
                  </ul>
                </div>
              </div>
            </label>
            <div class="field">
              <Button type="submit" full-width :loading="loading"
                >Reset password</Button
              >
            </div>
          </form>
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, sameAs } from "@vuelidate/validators";

import Button from "@/components/Button.vue";
import Menu from "@/components/Menu";
import resetPasswordMutation from "@/graphql/mutations/ResetPassword.gql";

export default {
  name: "ResetPasswordPage",
  components: {
    Menu,
    Button,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      id: null,
      password: null,
      confirm: null,
      errors: [],
      loading: false,
    };
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    async handleResetSubmit() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.loading = true;

      const { customerUserErrors } = await this.$apollo.mutate({
        mutation: resetPasswordMutation,
        variables: {
          resetUrl: window.location.href,
          password: this.password,
        },
      });

      this.loading = false;

      if (customerUserErrors) {
        this.errors = customerUserErrors;
        return;
      }

      window.location.href = "/account/login";
    },
  },
  validations() {
    return {
      password: { required },
      confirm: { sameAsPassword: sameAs(this.password) },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.login-page {
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0;
}

.forgotten-password-button {
  margin-top: 10px;
}
</style>
